import type { Collection } from '../actions/collection';
import type { SportType } from '~/model/SportType';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { fetchCollection } from '@/app/actions/server';
import { useApiErrorContext } from '@/app/components/Provider';
import { AcceptLanguage } from '~/const/locale';
import { RequestStatus, useRequestState } from '~/hooks/request/useRequestState';
import { ApiRoute } from '../utils/request/api-routes';

export function useSports({ sports: baseSports }: { sports: Collection<SportType> }) {
  const locale = useLocale();
  const [sports, setSports] = useState<Collection<SportType>>(baseSports);

  const { setError } = useApiErrorContext();
  const { startRequest, handleSuccess, handleError, status } = useRequestState();

  const isFetching = status === RequestStatus.PENDING;

  const handleFetchSports = async () => {
    startRequest();

    const fetchedSports = await fetchCollection<SportType>({
      pathname: ApiRoute.SPORTS,
      revalidate: 3600,
      headers: {
        acceptLanguage: AcceptLanguage[locale],
      },
      unpaginate: true,
    });

    if (fetchedSports['hydra:description']) {
      handleError();
      return setError(fetchedSports);
    }

    setSports(fetchedSports);
    handleSuccess();
  };

  return { sports, handleFetchSports, isFetching };
}
